import ConfirmationDialog from "@Components/app/common/confirmation-dialog";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Button, Stack, Typography } from "@mui/material";
import { useNotificationActions } from "@Services/notification-service/shared/use-notification-actions";

interface IUserRecoveryNotification {
  actionLabel: string;
  hideActionButton?: boolean;
  secondaryActions?: React.ReactNode;
  errorMessage?: string | null;
  isLoading: boolean;
  loadingLabel: string;
  message: string;
  onRecover: () => void;
  open: boolean;
  title: string;
}

const UserRecoveryNotification = ({
  actionLabel,
  hideActionButton = false,
  secondaryActions,
  errorMessage,
  isLoading,
  loadingLabel,
  message,
  onRecover,
  open,
  title,
}: IUserRecoveryNotification) => {
  const { i18n } = useI18n();
  const { handleLogout } = useNotificationActions();

  return (
    <ConfirmationDialog
      open={open}
      dialogProps={{
        open,
        disableEscapeKeyDown: true,
      }}
      iconProps={{
        icon: faTriangleExclamation,
        size: "4x",
        sx: {
          padding: theme => theme.spacing(2),
          color: theme => theme.palette.warning.main,
        },
      }}
      title={title}
      message={message}
      disableConfirm
      disableCancel
      buttonStackProps={{
        paddingTop: 0,
        direction: "column",
      }}
    >
      <>
        <Stack spacing={2}>
          {errorMessage && (
            <Typography variant="textS500" color="error.main">
              {errorMessage}
            </Typography>
          )}
          {!hideActionButton && (
            <Button variant="contained" fullWidth disabled={isLoading} onClick={onRecover}>
              {isLoading ? loadingLabel : actionLabel}
            </Button>
          )}
          {secondaryActions}
        </Stack>
        <Button fullWidth variant="text" disabled={isLoading} onClick={handleLogout}>
          {i18n("account.recovery.signout")}
        </Button>
      </>
    </ConfirmationDialog>
  );
};

export default UserRecoveryNotification;
